import React, { useContext } from 'react';
import { Breakpoint } from '@theme/tokens';

export const BreakpointContext = React.createContext<Breakpoint>('mobile');
export const useBreakpoint = () => useContext(BreakpointContext);
